
const baseUrl = process.env.REACT_APP_PAGE_BASE_URL
export {
    baseUrl
}
